import React from 'react'
// @material-ui
import MuiTextField from '@material-ui/core/TextField'
import { styled } from '@material-ui/core/styles'

const TextField = styled(MuiTextField)({
  // margin: 8,
  // width: '100%'
})

// export default TextField

export default ({ ...props }) => {
  return <TextField fullWidth {...props} />
}

// export default ({width,  ...props }) => {
//   return (
//     <Box width={width}>
//       <TextField fullWidth style={{ margin: 8 }} {...props}  />
//     </Box>
//   )
// }
